import { matchPath, useLocation } from 'react-router-dom'

import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import ButtonBase from '@mui/material/ButtonBase'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'

import NavigationLink from '../../components/NavigationLink'
import { useDrawer } from '../../hooks/useDrawer'
import { borderRadius } from '../../store/constant'
import { MenuItem } from './MenuLinks'

export default function NavItem({ item }: { item: MenuItem }) {
  const { isDrawerExpanded } = useDrawer()

  const { pathname } = useLocation()

  const isSelected = item.url
    ? !!matchPath({ path: item.url, end: false }, pathname)
    : false

  const Icon = item?.icon
  const itemIcon = Icon ? (
    <Icon stroke={1.5} sx={{ fontSize: 24, stroke: '1.5' }} />
  ) : (
    <FiberManualRecordIcon
      sx={{ width: isSelected ? 8 : 6, height: isSelected ? 8 : 6 }}
    />
  )

  return (
    <ListItemButton
      component={NavigationLink}
      to={item.url || ''}
      onClick={item.onClick}
      disableRipple={true}
      sx={{
        padding: isDrawerExpanded ? '8px 16px' : '0',
        color: 'grey.700',
        zIndex: 1201,
        borderRadius: `${borderRadius}px`,
        mb: 0.5,
        ml: isDrawerExpanded ? 4.5 : 0,
        '&:hover': {
          backgroundColor: 'secondary.main',
        },
        '&.Mui-selected': {
          backgroundColor: 'secondary.dark',
        },
        '&.Mui-selected:hover': {
          backgroundColor: 'secondary.dark',
        },
      }}
      selected={isSelected}
    >
      <ButtonBase
        aria-label='theme-icon'
        sx={{ borderRadius: `${borderRadius}px` }}
        disableRipple={true}
      >
        {!isDrawerExpanded && (
          <ListItemIcon
            sx={{
              color: isSelected ? 'white' : 'inherit',
              ...(!isDrawerExpanded && {
                borderRadius: `${borderRadius}px`,
                width: 46,
                height: 46,
                alignItems: 'center',
                justifyContent: 'center',
              }),
            }}
          >
            {itemIcon}
          </ListItemIcon>
        )}
      </ButtonBase>
      {isDrawerExpanded && (
        <ListItemText>
          <Typography
            noWrap
            variant='h5'
            sx={{
              color: 'inherit',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {item.title}
          </Typography>
        </ListItemText>
      )}
    </ListItemButton>
  )
}
